import { render, staticRenderFns } from "./NotaryProducts.vue?vue&type=template&id=40f5d201&"
import script from "./NotaryProducts.vue?vue&type=script&lang=ts&"
export * from "./NotaryProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports